module.exports = __webpack_public_path__ + "img/tema-1-12.e1888b08.svg";